<template>
  <div>

    <div class="innerBox" style="display: flex; flex-direction: row; align-items: center; padding: 7.5px 10px;">
      <button class="btn" style="font-size: 16px; color: #6C6C6C; font-weight: bold; padding: 4px" @click="goBack"><i class="fas fa-angle-left mr-2"></i>Back</button>
      <p class="mb-0" style="font-size: 16px; color: #B9B9B9; font-weight: 600;">| Leadtime >> Detail Report <i class="fas fa-angle-right"></i></p>
      <p class="mb-0 ml-1" style="font-size: 16px; color: #4B4B4B; font-weight: bold;">{{ filter.nopol }}</p>
    </div>
    
    <!-- Your content goes here -->
    <div class="innerBox mt-3">
      
      <!-- Stats Start -->
      <div style="display: flex; flex-direction: row; align-items: flex-start; justify-content: space-between; padding: 0 25px;">
        <mini-stats title="Nopol" :value="statsData != null ? statsData.nopol : 'Loading...'"></mini-stats>
        <mini-stats title="Leadtime Unit" :value="statsData != null ? `${statsData.percent_leadtime_unit}%` : 'Loading...'" />
        <mini-stats title="Avg. Leadtime Unit" :value="statsData != null ? `${statsData.avg_leadtime_unit} Days` : 'Loading...'" />
        <mini-stats title="Leadtime Truck" :value="statsData != null ? `${statsData.percent_leadtime_truck}%` : 'Loading...'" />
        <mini-stats title="Avg. Leadtime Truck" :value="statsData != null ? `${statsData.avg_leadtime_truck} Days` : 'Loading...'" />
      </div>
      <!-- Stats End -->

      <h4 style="font-size: 14px; color: black; font-weight: 600; margin-top: 40px; margin-left: 25px;">History Date ({{ moment(filter.start).format("DD MMM YYYY") }} to {{ moment(filter.end).format("DD MMM YYYY") }})</h4>

      <vue-universal-table
        v-if="statsData"
        :api_url="'/api/reports/lead-time-detail-bongkar-nopol'"
        :filter="filter"
        :fields="vue_universal_table.fields"
        :process_data="vue_universal_table.process_data"
        :disable_limit_per_page="true"
        :table_striped="false"
      ></vue-universal-table>

    </div>
    
  </div>
</template>


<script>
  import qs from 'qs'
  import moment from 'moment'

  import miniStats from './children/miniStats'

  export default {
    metaInfo : {
        title : `Leadtime Detail Report`
    },
    data () {
      let startDate = moment().startOf('month').format("YYYY-MM-DD");
      let currentDate = moment().format("YYYY-MM-DD");

      return {
        moment : moment,
        filter : {
          nopol : null,
          start : startDate,
          end : currentDate,
        },
        statsData : null,
        
        vue_universal_table : {
          fields : [
            {title: "Date", variable: "tanggal", date_format: "DD/MM/YYYY"},
            {title: "Tujuan", variable: "gudang"},
            {title: "Leadtime Unit", variable: "percent_leadtime_unit"},
            {title: "Avg. Leadtime Unit", variable: "avg_leadtime_unit"},
            {title: "Leadtime Truck", variable: "percent_leadtime_truck"},
            {title: "Avg. Leadtime Truck", variable: "avg_leadtime_truck"},
          ],
          process_data : `
            for (var i in data) {
              data[i].percent_leadtime_unit = data[i].percent_leadtime_unit + "%"
              data[i].avg_leadtime_unit = data[i].avg_leadtime_unit + " Days"
              data[i].percent_leadtime_truck = data[i].percent_leadtime_truck + "%"
              data[i].avg_leadtime_truck = data[i].avg_leadtime_truck + " Days"
            }
          `
        },
      }
    },
    components: {
      miniStats,
    },
    mounted() {
      this.filter.nopol = this.$route.params.nopol;
      if (this.$route.query.start) this.filter.start = this.$route.query.start;
      if (this.$route.query.end) this.filter.end = this.$route.query.end;

      if (this.filter.nopol == null || this.filter.nopol == '') this.nopol404();

      this.fetchStats();
    },
    methods: {
      nopol404 () {
        this.$swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Nopol tidak ditemukan!',
        })
        this.$router.go(-1);
      },
      goBack() {
        this.$router.go(-1); // Go back to the previous route
      },
      fetchStats () {
        this.$http.get(`/api/reports/lead-time-detail-bongkar-nopol-stats?${qs.stringify(this.filter, {skipNulls:true, arrayFormat: 'comma'})}`)
        .then((resp)=>{
          this.statsData = resp.data.data.total;

          if ( this.statsData.avg_leadtime_unit == null
            && this.statsData.percent_leadtime_unit == null
            && this.statsData.avg_leadtime_truck == null
            && this.statsData.percent_leadtime_truck == null
          ) this.nopol404();
        })
        .catch((err)=>{console.log(err)})
      },
    },
  };
</script>
  
<style scoped>
  .innerBox {
    background-color: white;
    border-radius: 8px;
    box-shadow: 0px 3px 10px #0000000F;
    padding: 25px;
  }
</style>